module.exports = __webpack_public_path__ + "static/media/delete-icon.c4334548.svg";